import { z } from 'zod';
import { emailSchema, idSchema, isoDateSchema, pseudoSchema } from './common';
import { memberRoleSchema, memberStatusSchema } from '../enums';
/** Écran 08 — « + Inviter par email ». */
export const inviteMemberSchema = z.object({
    email: emailSchema,
});
/** Écran 07 — « Modifier le profil ». L'email n'est pas modifiable : il identifie le membre. */
export const updateProfileSchema = z.object({
    pseudo: pseudoSchema.optional(),
    avatarUrl: z.url().max(2048).nullish(),
});
export const memberSchema = z.object({
    id: idSchema,
    pseudo: pseudoSchema,
    avatarUrl: z.string().nullable(),
    role: memberRoleSchema,
    status: memberStatusSchema,
    createdAt: isoDateSchema,
});
/** Vue admin : ajoute l'email, que les membres ordinaires ne voient pas les uns des autres. */
export const adminMemberSchema = memberSchema.extend({
    email: emailSchema,
    tastingCount: z.number().int().min(0),
});
export const pendingInvitationSchema = z.object({
    id: idSchema,
    email: emailSchema,
    sentAt: isoDateSchema,
    expiresAt: isoDateSchema,
    /** Jours restants, pré-calculés côté API pour que la maquette affiche « 4 j » sans logique. */
    daysLeft: z.number().int(),
});
/**
 * Une invitation qu'on vient d'émettre — création ou renvoi.
 *
 * Elle porte son lien en clair, ce que la liste des invitations en attente ne pourra jamais
 * faire : le jeton est haché en base, il n'existe en clair qu'à l'instant où on le fabrique.
 * D'où deux vues plutôt qu'un champ optionnel — le type dit à quel moment le lien existe.
 *
 * Ce lien est un secret : il ouvre le cercle, qui n'a pas d'inscription publique. Il se
 * montre à qui vient de l'émettre, jamais il ne se journalise ni ne transite par une URL.
 */
export const issuedInvitationSchema = pendingInvitationSchema.extend({
    link: z.url(),
    /** Faux si le courrier n'a pas pu partir : le lien reste alors la seule voie. */
    mailed: z.boolean(),
});
/** Écran 07 — « Votre part des anges » : 12 séances · 34 notes · 8,4 moyenne. */
export const memberStatsSchema = z.object({
    sessionsAttended: z.number().int().min(0),
    tastingsSubmitted: z.number().int().min(0),
    /** Moyenne des notes données, en dixièmes. Null si le membre n'a encore rien noté. */
    averageGiven: z.number().int().nullable(),
    bestNoseCount: z.number().int().min(0),
});
/**
 * Nomination d'un maître de chai.
 *
 * `ADMIN` est accepté par le schéma — c'est une valeur légitime du domaine — mais refusé
 * par le service : le rôle de fondateur vient de l'amorçage, jamais d'un appel HTTP. La
 * validation dit ce qu'est un rôle, la règle métier dit ce qu'on a le droit d'en faire.
 */
export const setMemberRoleSchema = z.object({ role: memberRoleSchema });
//# sourceMappingURL=member.js.map